import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { UsuarioService } from '../../services/usuario.service';

declare const $: any;

export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;
  children?: ChildrenItems[];
  permiteAtendimento?: boolean;
}

export interface ChildrenItems {
  path: string;
  title: string;
  ab: string;
  type?: string;
}

export const ROUTES: RouteInfo[] = [
  {
    path: '/pedidos-list',
    title: 'Pedidos',
    type: 'link',
    icontype: 'business_center',
    permiteAtendimento: true,
  },
  {
    path: '/cadastros',
    title: 'Cadastros',
    type: 'sub',
    icontype: 'apps',
    collapse: 'cadastros',
    children: [
      { path: 'cliente-list', title: 'Clientes', ab: 'C' },
      { path: 'banner-list', title: 'Banners', ab: 'BN' },
      { path: 'promocao-list', title: 'Promoções', ab: '$$$' },
      { path: 'produto-agrupado-list', title: 'Produtos Agrupados', ab: 'PA' },
      { path: 'produto-list', title: 'Produtos', ab: 'P' },
      { path: 'categoria-list', title: 'Categorias', ab: 'CP' },
      { path: 'embalagem-list', title: 'Embalagens', ab: 'E' },
      { path: 'situacao-list', title: 'Situações', ab: 'ST' },
      { path: 'horario-funcionamento-list', title: 'Horário Funcionamento', ab: 'HF' },

      { path: 'unidade-list', title: 'Unidades', ab: 'UN' },

      { path: 'usuario-list', title: 'Usuarios', ab: 'U' },
    ],
  },
  {
    path: '/entrega',
    title: 'Entrega',
    type: 'sub',
    icontype: 'place',
    collapse: 'entrega',
    children: [
      { path: 'faixa-entrega-list', title: 'Faixa Entrega', ab: 'FKm' },
      { path: 'bairro-list', title: 'Bairros', ab: 'Brs' },
      { path: 'taxa-list', title: 'Taxas', ab: 'Tx' },
      { path: 'tempo-entrega-list', title: 'Tempo Entrega', ab: 'TE' },
      { path: 'tipo-entrega-list', title: 'Tipo Entrega', ab: 'TPE' },
      { path: 'cidade-list', title: 'Cidade', ab: 'CID' },
    ],
  },
  {
    path: '/configuracao',
    title: 'Configurações',
    type: 'link',
    icontype: 'settings',
  },
  {
    path: '/senha-form',
    title: 'Alterar Senha',
    type: 'link',
    icontype: 'vpn_key',
    permiteAtendimento: true,
  },
];
@Component({
  selector: 'app-sidebar-cmp',
  templateUrl: 'sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  title = '';

  constructor(private usuarioService: UsuarioService) {}

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  ngOnInit() {
    const usuario = this.usuarioService.getUsuario();
    if (usuario) {
      this.menuItems = ROUTES.filter((menuItem) => {
        if (usuario.atendente) {
          return menuItem.permiteAtendimento === true;
        }
        return menuItem;
      });
    }
  }
  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
      const ps = new PerfectScrollbar(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
    }
  }
  isMac(): boolean {
    let bool = false;
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
      bool = true;
    }
    return bool;
  }
}
